<div id="map">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423.9625031557223!2d11.87370177544211!3d45.40451708457477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477eda51e12e0131%3A0xfa88637b526a1157!2sVia%20dei%20Papafava%2C%207%2C%2035122%20Padova%20PD%2C%20Italia!5e0!3m2!1sro!2sro!4v1712945424569!5m2!1sro!2sro" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

<style>
    #map{
        width: 100%;
        height: 400px;
    }
    #map iframe{
        width: 100%;
        height: 400px;
    }
    @media screen and (max-width: 768px) {
        #map{
            width: 100%;
        }
    }
</style>